import { LoadingStatusType } from "@/enums/enums";
import API from "@/service/Index";

import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class VideoFeedback extends VuexModule {
  public userFeedbackVideo: any = [];
  public userFeedbackVideoLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getUserFeedbackVideo(): any {
    return this.userFeedbackVideo;
  }
  get getUserFeedbackVideoLoadingStatus(): LoadingStatusType {
    return this.userFeedbackVideoLoadingStatus;
  }

  @Mutation
  public MutationSetUserFeedbackVideo(userFeedbackVideo: any) {
    this.userFeedbackVideo = userFeedbackVideo;
  }

  @Mutation
  public MutationSetUserFeedbackVideoLoadingStatus(status: LoadingStatusType) {
    this.userFeedbackVideoLoadingStatus = status;
  }

  @Action
  public DoSendVideoFeedback(_input: any) {
    return new Promise<boolean>((resolve) => {
      const dateTimeNow = new Date();
      const input = {
        ..._input,
        createdDate: dateTimeNow,
      };
      API.UserService.DoSendVideoFeedback(input).then((res) => {
        if (res.responseCode.IsSuccess()) {
          const newUserFeedbackVideo = [...this.context.getters.getUserFeedbackVideo, res.feedbackVideo];
          this.context.commit("MutationSetUserFeedbackVideo", newUserFeedbackVideo);
        }
        resolve(true);
      });
    });
  }
  @Action
  public DoGetVideoFeedback(_input: any) {
    this.context.commit("MutationSetUserFeedbackVideoLoadingStatus", LoadingStatusType.Loading);
    API.UserService.DoGetVideoFeedback(_input).then((res) => {
      if (res.responseCode.IsSuccess()) {
        this.context.commit("MutationSetUserFeedbackVideo", res.userFeedbackVideo);
        this.context.commit("MutationSetUserFeedbackVideoLoadingStatus", LoadingStatusType.Success);
      } else {
        this.context.commit("MutationSetUserFeedbackVideoLoadingStatus", LoadingStatusType.Fail);
      }
    });
  }
}
